/**
 * @desc 钉钉对私账户创建
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.StaffPaymentInfoAddRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basic/staffPaymentInfo/saveStaffPaymentInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
